/**
 * The GDPR retention purge overwrites text fields with a marker once a trip is old enough.
 *
 * Mirrors RetentionStrategy::MARKER_TEXT on the PHP side. It is a non-empty string, so anything
 * asking "did they give us this?" counted it as supplied: a returning guest's profile read as
 * complete, nothing prompted them to enter a passport again, and the check-in gates passed on
 * values that mean nothing. A field we redacted is a field we do not hold.
 *
 * Deliberately free of imports — accountOverview and the field validators both need it, and
 * routing it through the validators would pull libphonenumber-js into every account bundle.
 */
export const REDACTION_MARKER = '[REDACTED]';

/**
 * @param {*} value
 * @returns {boolean}
 */
export const isRedacted = value => String(value == null ? '' : value).trim() === REDACTION_MARKER;
